export default "__VITE_ASSET__Te3tukMmVb9_aFLh1yI7Ag__"